import {
  MarketingContentCreateMutationOptions,
  MarketingContentUpdateMutationOptions,
  useMarketingContentCreateMutation as useApolloMarketingContentCreateMutation,
  useMarketingContentUpdateMutation as useApolloMarketingContentUpdateMutation,
} from '@occc/graphql';

import { useMutation } from '../utils';

export const useMarketingContentCreateMutation = (
  baseOptions?: MarketingContentCreateMutationOptions,
) => useMutation(useApolloMarketingContentCreateMutation, baseOptions);

export const useMarketingContentUpdateMutation = (
  baseOptions?: MarketingContentUpdateMutationOptions,
) => useMutation(useApolloMarketingContentUpdateMutation, baseOptions);
